const isErrorWithMessage = (error) => typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof error.message === 'string';
const toErrorWithMessage = (maybeError) => {
    if (isErrorWithMessage(maybeError))
        return maybeError;
    try {
        return new Error(JSON.stringify(maybeError));
    }
    catch {
        // Fallback in case there's an error stringifying the maybeError
        // like with circular references for example.
        return new Error(String(maybeError));
    }
};
const getErrorMessage = (error) => toErrorWithMessage(error).message;

export { getErrorMessage as g };
//# sourceMappingURL=index-chunk.esm.js.map
